'use client'
import { ChevronDownIcon } from 'primitives/icons'

export function ScrollToCompare({ label }: { label: string }) {
  const scrollToCompareFeatures = () => {
    document
      .querySelector('#compare-features')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    // oxlint-disable-next-line react/button-has-type
    <button
      className="text-16 mx-auto flex items-center px-[30px] py-[10px] font-bold"
      onClick={scrollToCompareFeatures}
    >
      {label} <ChevronDownIcon className="size-5" />
    </button>
  )
}
